export { default as CelebrationIcon } from "./celebration-icon";
export { default as ExamIcon } from "./exams-icon";
export { default as HolidayIcon } from "./holiday-icon";
export { default as PtmIcon } from "./ptm-icon";
